import React from 'react';
import icon1 from '../../images/icons/icon_calendar.svg';
import icon2 from '../../images/icons/icon_user.svg';
import icon4 from '../../images/icons/icon_eye.svg';

import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';
import Link from 'shared/SlashLink';
import BlogSidebar from '../BlogSidebar';

const renderBlock = (block, idx) => {
    if (block.type === 'h2') {
        return <h3 key={idx} className="details_item_info_title" style={{ marginTop: 28 }}>{block.text}</h3>;
    }
    if (block.type === 'h3') {
        return <h4 key={idx} style={{ marginTop: 22, color: 'var(--bs-dark)' }}>{block.text}</h4>;
    }
    if (block.type === 'list') {
        return (
            <ul key={idx} className="icon_list unordered_list_block mb-3">
                {block.items.map((item, i) => (
                    <li key={i}>
                        <span className="icon_list_icon"><i className="fa-solid fa-circle fa-fw" aria-hidden="true" style={{ color: 'var(--bs-primary)', fontSize: '.5rem' }}></i></span>
                        <span className="icon_list_text">{item}</span>
                    </li>
                ))}
            </ul>
        );
    }
    if (block.type === 'callout') {
        return (
            <div key={idx} style={{
                background: 'var(--bs-primary-bg-subtle)',
                borderLeft: '4px solid var(--bs-primary)',
                borderRadius: '8px',
                padding: '18px 22px',
                margin: '22px 0',
                color: 'var(--bs-dark)',
                fontWeight: 500,
            }}>
                {block.text}
            </div>
        );
    }
    if (block.type === 'stats') {
        return (
            <div key={idx} className="row" style={{ margin: '26px 0' }}>
                {block.items.map((s, i) => (
                    <div className="col-md-3 col-6 mb-3" key={i}>
                        <div style={{
                            background: 'var(--bs-primary)', color: '#fff', borderRadius: 14,
                            padding: '22px 16px', textAlign: 'center', height: '100%',
                        }}>
                            <div style={{ fontSize: '1.9rem', fontWeight: 800, lineHeight: 1.1 }}>{s.value}</div>
                            <div style={{ fontSize: '.78rem', opacity: 0.9, marginTop: 6 }}>{s.label}</div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
    if (block.type === 'streams') {
        return (
            <div key={idx} style={{ margin: '26px 0' }}>
                {block.heading && <h3 className="details_item_info_title" style={{ marginBottom: 16 }}>{block.heading}</h3>}
                <div className="row">
                    {block.items.map((s, i) => (
                        <div className="col-md-6 mb-3" key={i}>
                            <div style={{
                                display: 'flex', gap: 14, alignItems: 'flex-start',
                                background: '#fff', border: '1px solid var(--bs-border-color)',
                                borderRadius: 12, padding: '18px 20px', height: '100%',
                            }}>
                                <span style={{
                                    flex: '0 0 auto', width: 44, height: 44, borderRadius: 10,
                                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                    background: 'var(--bs-primary-bg-subtle)', color: 'var(--bs-primary)', fontSize: 18,
                                }}>
                                    <i className={`fa-solid ${s.icon}`} aria-hidden="true"></i>
                                </span>
                                <div>
                                    <div style={{ fontWeight: 700, color: 'var(--bs-dark)', marginBottom: 3 }}>
                                        {s.title}{s.amount && <span style={{ color: 'var(--bs-primary)', fontWeight: 700 }}> — {s.amount}</span>}
                                    </div>
                                    <div style={{ fontSize: '.86rem' }}>{s.text}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    if (block.type === 'compare') {
        const col = (side, accent, icon) => (
            <div className="col-md-6 mb-3">
                <div style={{ border: `1px solid ${accent}`, borderRadius: 12, overflow: 'hidden', height: '100%' }}>
                    <div style={{ background: accent, color: '#fff', padding: '12px 18px', fontWeight: 700 }}>
                        <i className={`fa-solid ${icon}`} aria-hidden="true" style={{ marginRight: 8 }}></i>{side.title}
                    </div>
                    <ul style={{ listStyle: 'none', margin: 0, padding: '16px 18px' }}>
                        {side.items.map((it, i) => (
                            <li key={i} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', marginBottom: 10, fontSize: '.88rem' }}>
                                <i className={`fa-solid ${icon}`} aria-hidden="true" style={{ marginTop: 3, color: accent }}></i>
                                <span>{it}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
        return (
            <div key={idx} className="row" style={{ margin: '26px 0' }}>
                {col(block.left, '#b3261e', 'fa-xmark')}
                {col(block.right, 'var(--bs-primary)', 'fa-check')}
            </div>
        );
    }
    if (block.type === 'services') {
        return (
            <div key={idx} style={{ margin: '22px 0' }}>
                {block.heading && <h3 className="details_item_info_title" style={{ marginBottom: 16 }}>{block.heading}</h3>}
                <div className="row">
                    {block.items.map((s, i) => (
                        <div className="col-md-6 mb-3" key={i}>
                            <Link
                                to={s.to}
                                onClick={() => window.scrollTo(10, 0)}
                                style={{
                                    display: 'block',
                                    padding: '14px 18px',
                                    background: '#fff',
                                    border: '1px solid var(--bs-border-color)',
                                    borderRadius: 10,
                                    textDecoration: 'none',
                                    color: 'inherit',
                                    height: '100%',
                                }}
                            >
                                <div style={{ color: 'var(--bs-primary)', fontWeight: 700, fontSize: '.95rem', marginBottom: 4 }}>
                                    {s.label} <i className="fa-solid fa-arrow-up-right" aria-hidden="true" style={{ fontSize: '.75rem', marginLeft: 4 }}></i>
                                </div>
                                {s.note && <div style={{ fontSize: '.8rem', color: 'var(--bs-body-color)' }}>{s.note}</div>}
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    if (block.type === 'figure') {
        return (
            <figure key={idx} style={{ margin: '26px 0' }}>
                <img src={block.src} alt={block.alt || ''} loading="lazy" style={{ width: '100%', borderRadius: 12, display: 'block' }} />
                {block.caption && (
                    <figcaption style={{ fontSize: '.82rem', color: 'var(--bs-secondary-color, #6c757d)', marginTop: 8, textAlign: 'center' }}>{block.caption}</figcaption>
                )}
            </figure>
        );
    }
    return <p key={idx}>{block.text}</p>;
};

const findRelated = (current, all, limit = 3) => {
    const tags = new Set(current.tags || []);
    const others = all.filter((b) => b.slug !== current.slug);
    // Tag-matched posts first (most shared tags win); then fall back to other
    // recent posts so EVERY article always links out to `limit` related pieces.
    const picked = others
        .map((b) => ({ post: b, score: (b.tags || []).reduce((acc, t) => acc + (tags.has(t) ? 1 : 0), 0) }))
        .filter((x) => x.score > 0)
        .sort((a, b) => b.score - a.score)
        .slice(0, limit)
        .map((x) => x.post);
    if (picked.length < limit) {
        for (const b of others) {
            if (picked.length >= limit) break;
            if (!picked.includes(b)) picked.push(b);
        }
    }
    return picked;
};

const BlogSingle = () => {
    const { slug } = useParams();
    const post = blogs.find((b) => b.slug === slug);
    const ClickHandler = () => window.scrollTo(10, 0);

    if (!post) {
        return (
            <section className="blog_details_section section_space bg-light">
                <div className="container">
                    <h2>Post not found</h2>
                    <p>We couldn’t find that article. <Link to="/blog" onClick={ClickHandler}>Browse all posts →</Link></p>
                </div>
            </section>
        );
    }

    const related = findRelated(post, blogs);

    return (
        <section className="blog_details_section section_space bg-light">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="details_item_image">
                            <img src={post.bSingle} alt={post.title} />
                        </div>
                        <div className="post_meta_wrap mb-4">
                            <ul className="category_btns_group unordered_list">
                                <li><Link onClick={ClickHandler} to={`/blog?tag=${encodeURIComponent(post.tags?.[0] || '')}`}>{post.thumb}</Link></li>
                                <li><Link onClick={ClickHandler} to={`/blog?cat=${encodeURIComponent(post.category)}`}>{post.category}</Link></li>
                            </ul>
                            <ul className="post_meta unordered_list">
                                <li>
                                    <Link onClick={ClickHandler} to={'/blog'}>
                                        <img src={icon1} alt="Calendar" /> {post.create_at}
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} to={'/blog'}>
                                        <img src={icon2} alt="Author" /> {post.author}
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} to={'/blog'}>
                                        <img src={icon4} alt="Read time" /> {post.readTime} min read
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <h2 className="details_item_title">{post.title}</h2>
                        <p style={{ fontSize: '1.05rem', color: 'var(--bs-body-color)', fontStyle: 'italic' }}>{post.excerpt}</p>

                        {(post.body || []).map((block, idx) => renderBlock(block, idx))}

                        {post.tags && post.tags.length > 0 && (
                            <div className="mt-5 pt-3" style={{ borderTop: '1px solid var(--bs-border-color)' }}>
                                <strong style={{ marginRight: 12, color: 'var(--bs-dark)' }}>Tags:</strong>
                                {post.tags.map((tag) => (
                                    <Link
                                        key={tag}
                                        to={`/blog?tag=${encodeURIComponent(tag)}`}
                                        onClick={ClickHandler}
                                        style={{
                                            display: 'inline-block',
                                            padding: '4px 12px',
                                            margin: '4px 6px 4px 0',
                                            borderRadius: '20px',
                                            background: 'var(--bs-primary-bg-subtle)',
                                            color: 'var(--bs-primary)',
                                            fontSize: '.8rem',
                                            fontWeight: 600,
                                            textDecoration: 'none',
                                        }}
                                    >
                                        {tag}
                                    </Link>
                                ))}
                            </div>
                        )}

                        {related.length > 0 && (
                            <div className="mt-5 pt-4">
                                <h3 className="details_item_info_title mb-4">Related Posts</h3>
                                <div className="row">
                                    {related.map((r) => (
                                        <div className="col-md-4 mb-3" key={r.slug}>
                                            <Link onClick={ClickHandler} to={`/blog-single/${r.slug}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
                                                <div style={{ background: '#fff', border: '1px solid var(--bs-border-color)', borderRadius: '10px', overflow: 'hidden', height: '100%' }}>
                                                    <img src={r.screens} alt={r.title} style={{ width: '100%', height: 140, objectFit: 'cover' }} />
                                                    <div style={{ padding: '14px 16px' }}>
                                                        <div style={{ fontSize: '.72rem', color: 'var(--bs-primary)', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '.08em' }}>{r.thumb}</div>
                                                        <div style={{ fontSize: '.95rem', fontWeight: 600, color: 'var(--bs-dark)', lineHeight: 1.3 }}>{r.title}</div>
                                                        <div style={{ fontSize: '.75rem', color: 'var(--bs-body-color)', marginTop: 6 }}>{r.create_at} · {r.readTime} min read</div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <BlogSidebar currentSlug={post.slug} />
                </div>
            </div>
        </section>
    );
};

export default BlogSingle;
